import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { DocumentCopyIcon } from "@helloaudio/icons/twotone";
import { PuffLoader } from "react-spinners";
import { Label, LinkButtonBlue } from "@helloaudio/ui";

function Loading({ size = 100 }) {
  return (
    <div className="tw-flex tw-items-center tw-justify-center tw-my-4 tw-w-[300px]">
      <div className="tw-flex tw-flex-col tw-items-center tw-justify-center">
        <PuffLoader color="#32325d" size={size} aria-label="Loading Spinner" data-testid="loader" />
        <div className="tw-inline-block tw-mt-2 tw-text-sm tw-font-Montserrat">Loading</div>
      </div>
    </div>
  );
}

Loading.propTypes = {
  size: PropTypes.number,
};

function ShareEpisode({
  existingFeedEpisodeId,
  feedEpisode,
  feedId,
  getEmbedCode,
  getEmbedCodeSlim,
  getEpisodeShareCode,
}) {
  const [showIframe, setShowIframe] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowIframe(true);
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, []);

  const renderEmbeddablePlayer = (height, code, slim = false) => (
    <React.Fragment>
      <LinkButtonBlue
        className="tw-mb-8 tw-p-0 text-btn-primary tw-cursor-pointer episode-uploader-text"
        onClick={(e) => {
          e.preventDefault();
          if (slim) {
            getEmbedCodeSlim(existingFeedEpisodeId, code);
            return;
          }
          getEmbedCode(existingFeedEpisodeId, code);
        }}
      >
        <DocumentCopyIcon className="tw-w-4 tw-mr-2 text-btn-primary" />
        <div className="tw-flex tw-text-base tw-text-sm tw-font-medium copy-embed text-btn-primary">
          Copy Embed Code for {slim ? "Slim " : ""}Embeddable Player
        </div>
      </LinkButtonBlue>
      <iframe
        height={showIframe ? height : 0}
        onLoad={() => setShowIframe(true)}
        src={`${process.env.API_URL}/player?episodeId=${existingFeedEpisodeId}&code=${code}${
          slim ? "&simple=true" : ""
        }`}
        style={{
          width: "100%",
          height: `${showIframe ? height : 0}px`,
          border: "0",
          overflow: "hidden",
        }}
      />
      {!showIframe && <Loading size={30} />}
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <Label className="tw-cursor-pointer tw-my-4 tw-text-sm">Embeddable Players</Label>
      {feedEpisode.status === "active" ? (
        <div className="tw-mb-4">
          <div className="tw-mb-8 tw-w-full">
            <LinkButtonBlue
              className="tw-p-0 text-btn-primary tw-flex tw-items-center tw-cursor-pointer episode-uploader-text"
              onClick={(e) => {
                e.preventDefault();
                getEpisodeShareCode(existingFeedEpisodeId, feedEpisode.code);
              }}
            >
              <DocumentCopyIcon className="tw-w-4 tw-mr-2 text-btn-primary" />
              <div className="tw-flex tw-text-base tw-text-sm tw-font-medium text-btn-primary">
                Copy Sharable Link
              </div>
            </LinkButtonBlue>
          </div>
          <div className="tw-mb-4 tw-mr-2 tw-w-full">
            {feedEpisode.status === "active" && feedId && (
              <div>{renderEmbeddablePlayer(100, feedEpisode.code)}</div>
            )}
          </div>
          <div
            className="tw-mb-4 tw-ml-0 md-tw-ml-2 tw-flex tw-w-full"
            style={{ alignItems: "end" }}
          >
            {feedEpisode.status === "active" && feedId && (
              <div>{renderEmbeddablePlayer(35, feedEpisode.code, true)}</div>
            )}
          </div>
        </div>
      ) : (
        <div className="tw-mb-4">
          <div className="tw-mb-8 tw-w-full">
            <LinkButtonBlue
              className="tw-cursor-not-allowed tw-flex tw-items-center tw-opacity-70 tw-p-0 tw-text-gray-500 hover:tw-text-gray-500"
              disabled
              onClick={(e) => e.preventDefault()}
            >
              <DocumentCopyIcon className="tw-w-4 tw-mr-2" />
              <div className="tw-flex tw-text-base tw-text-sm tw-font-medium">
                Copy Sharable Link
              </div>
            </LinkButtonBlue>
          </div>
          <div className="tw-mb-4 tw-mr-2 tw-w-full">
            <div className="tw-flex tw-items-center tw-justify-center tw-w-full tw-h-24 tw-bg-gray-100 tw-rounded-md">
              <div className="tw-flex tw-flex-col tw-items-center tw-justify-center">
                <div className="tw-text-sm tw-font-Montserrat tw-text-gray-500">
                  Publish the episode to make it sharable.
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

ShareEpisode.propTypes = {
  existingFeedEpisodeId: PropTypes.string,
  feedEpisode: PropTypes.object,
  feedId: PropTypes.string,
  getEmbedCode: PropTypes.func,
  getEmbedCodeSlim: PropTypes.func,
  getEpisodeShareCode: PropTypes.func,
};

export default ShareEpisode;
